module.exports = __webpack_public_path__ + "static/media/reset-password-bg.5490a5be.png";